/* Mindset Media Group Site — first-paint-safe shell v3.11.2.
   Structural ownership is Liquid/CSS. This runtime performs metadata and a
   non-layout-affecting Back-to-Top enhancement only. */
(() => {
  'use strict';
  if (window.__MMG_PAGE_SHELL_V3112__) return;
  window.__MMG_PAGE_SHELL_V3112__ = true;
  const html=document.documentElement;
  const path=(location.pathname||'/').replace(/\/+$/,'')||'/';
  const handle=path.startsWith('/pages/')?path.slice(7):'';
  html.dataset.mmgPageShell='first-paint-v3112';
  if(handle) html.dataset.mmgApprovedPageV38=handle;
  html.dataset.mmgBrandAlignmentV38='experience-first-governed';

  const ATTR='data-mmg-global-backtop';
  let button=null,tick=false;
  const reduced=!!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  function setState(){tick=false;if(!button?.isConnected)button=document.querySelector(`[${ATTR}]`);button?.classList.toggle('is-visible',(scrollY||pageYOffset||0)>720)}
  function requestState(){if(tick)return;tick=true;requestAnimationFrame(setState)}
  function ensure(){
    if(!document.body)return;
    button=document.querySelector(`[${ATTR}]`);
    if(!button){button=document.createElement('button');button.className='mmg-global-backtop';button.type='button';button.setAttribute(ATTR,'true');button.setAttribute('aria-label','Back to top');button.setAttribute('title','Back to top');button.innerHTML='<span aria-hidden="true">↑</span>';document.body.appendChild(button);button.addEventListener('click',()=>{try{scrollTo({top:0,left:0,behavior:reduced?'auto':'smooth'})}catch(_){scrollTo(0,0)}})}
    setState();
  }
  function init(){ensure();addEventListener('scroll',requestState,{passive:true});addEventListener('resize',requestState,{passive:true});addEventListener('pageshow',setState);document.addEventListener('shopify:section:load',setState)}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
